export const EMAIL_BUILDER_Z_LAYERS = {
  canvas: 0,
  shell: {
    underlay: 99,
    ui: 100,
    banner: 101,
  },
} as const;
